import { useEffect } from 'react';

function OptinMonsterScript() {
    useEffect(() => {
        // Check if the script already exists to prevent duplicate loading
        if (!document.querySelector('#optinmonster-script')) {
            const script = document.createElement('script');
            script.id = 'optinmonster-script';
            script.src = 'https://a.omappapi.com/app/js/api.min.js';
            script.async = true;
            script.dataset.user = '344827';
            script.dataset.account = '364718';

            // Optional: Add success and error handling
            script.onload = () => console.log('OptinMonster script loaded successfully.');
            script.onerror = () => console.error('Failed to load OptinMonster script.');

            document.head.appendChild(script);
        }
    }, []);

    return null;
}

export default OptinMonsterScript;
